import { render } from "./IndividualOnboarding.vue?vue&type=template&id=61987e4d&scoped=true&ts=true"
import script from "./IndividualOnboarding.vue?vue&type=script&lang=ts"
export * from "./IndividualOnboarding.vue?vue&type=script&lang=ts"

import "./IndividualOnboarding.vue?vue&type=style&index=0&id=61987e4d&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61987e4d"]])

export default __exports__